import { render, staticRenderFns } from "./rg-button.vue?vue&type=template&id=5f4fd50e&"
import script from "./rg-button.vue?vue&type=script&lang=js&"
export * from "./rg-button.vue?vue&type=script&lang=js&"
import style0 from "./rg-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports